import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { ICampaignTemplate } from "@/interfaces/campaign-template.interfaces";
import campaignTemplateService from "@/services/campaign-template.service";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetTemplatesReturn = RequestsBaseReturn<PaginatedResponse<ICampaignTemplate> | null>;

export type UseGetTemplatesProps = Partial<RequestPagination>;

type GetTemplatesSwrParams = [string, number, number];

const useGetCampaignTemplates = ({
  pageNumber = 1,
  pageSize = 200,
}: UseGetTemplatesProps = {}): UseGetTemplatesReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<ICampaignTemplate>, Error, GetTemplatesSwrParams>(
    [SWR_KEYS.getCampaignTemplates, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      campaignTemplateService.getAll({
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetCampaignTemplates;
